import { useClockNudgeStore } from "@/stores/clockNudgeStore";

// Exposes `this.$clockNudge(mode)` returning a Promise<boolean>:
//   true  => user chose "Continue in web" (or the nudge is disabled)
//   false => user chose "Download the app" / dismissed
// Use it to gate web clock-in/out actions, e.g.:
//   if (!(await this.$clockNudge('in'))) return;
export default {
  install(Vue) {
    Vue.prototype.$clockNudge = (mode = "in") =>
      useClockNudgeStore().prompt(mode);
  },
};
